type SessionStorageCache<T> = {
  expiresAt: number;
  value: T;
};

const isSessionStorageAvailable = () => {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
};

export const getSessionStorageWithExpiry = <T>(key: string): T | null => {
  if (!isSessionStorageAvailable()) {
    return null;
  }

  const rawValue = sessionStorage.getItem(key);

  if (!rawValue) {
    return null;
  }

  try {
    const cache = JSON.parse(rawValue) as SessionStorageCache<T>;

    if (!cache || typeof cache.expiresAt !== "number" || cache.expiresAt <= Date.now()) {
      sessionStorage.removeItem(key);
      return null;
    }

    return cache.value;
  } catch (error) {
    sessionStorage.removeItem(key);
    return null;
  }
};

export const setSessionStorageWithExpiry = <T>(
  key: string,
  value: T,
  ttlMs: number
) => {
  if (!isSessionStorageAvailable()) {
    return;
  }

  const cache: SessionStorageCache<T> = {
    expiresAt: Date.now() + ttlMs,
    value,
  };

  sessionStorage.setItem(key, JSON.stringify(cache));
};

export const removeSessionStorageWithExpiry = (key: string) => {
  if (!isSessionStorageAvailable()) {
    return;
  }

  sessionStorage.removeItem(key);
};
